import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type StatusPillTone = 'good' | 'warn' | 'blue' | 'red';

const toneClass: Record<StatusPillTone, { borderColor: string; bg: string; color: string }> = {
  good: { borderColor: 'signal.good/20', bg: 'signal.good/10', color: 'signal.good' },
  warn: { borderColor: 'signal.warn/25', bg: 'signal.warn/10', color: 'signal.warn' },
  blue: { borderColor: 'signal.blue/20', bg: 'signal.blue/10', color: 'signal.blue' },
  red: { borderColor: 'signal.bad/20', bg: 'signal.bad/10', color: 'signal.bad' },
};

const dotShadow: Record<StatusPillTone, string> = {
  good: '0 0 18px var(--oq-colors-signal-good)',
  warn: '0 0 18px var(--oq-colors-signal-warn)',
  blue: '0 0 18px var(--oq-colors-signal-blue)',
  red: '0 0 18px var(--oq-colors-signal-bad)',
};

const dotBg: Record<StatusPillTone, string> = {
  good: 'signal.good',
  warn: 'signal.warn',
  blue: 'signal.blue',
  red: 'signal.bad',
};

interface StatusPillProps {
  tone?: StatusPillTone;
  dot?: boolean;
  className?: string;
  children: ReactNode;
}

export function StatusPill({ tone = 'blue', dot = true, className, children }: StatusPillProps) {
  const t = toneClass[tone];
  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      gap="2"
      borderRadius="full"
      borderWidth="1px"
      px="2.5"
      py="1"
      fontSize="xs"
      fontWeight="bold"
      textTransform="uppercase"
      letterSpacing="wide"
      borderColor={t.borderColor}
      bg={t.bg}
      color={t.color}
      className={className}
    >
      {dot ? (
        <Box
          as="span"
          boxSize="1.5"
          borderRadius="full"
          bg={dotBg[tone]}
          boxShadow={dotShadow[tone]}
        />
      ) : null}
      {children}
    </Box>
  );
}